<template>
  <div>
    <div class="flex flex-wrap -mx-2">

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Tipo de documento"
          :required="true"
          v-model="form.identifierType"
          :items="identifierTypes"
          defaultOption="Elegir tipo de documento"
          :error="v.identifierType.$error && !v.identifierType.required ? 'Tipo de documento es requerido' : ''"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Número de documento"
          :required="true"
          v-model="form.identifier"
          placeholder="Ingresar número de documento"
          :error="v.identifier.$error
            ? (!v.identifier.required ? 'Número de documento es requerido'
              : !v.identifier.numeric  ? 'Debe ser numérico' : '')
            : ''"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Apellido paterno"
          :required="true"
          v-model="form.lastNamePaternal"
          placeholder="Ingresar apellido paterno"
          :error="v.lastNamePaternal.$error && !v.lastNamePaternal.required ? 'Apellido paterno es requerido' : ''"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Apellido materno"
          v-model="form.lastNameMaternal"
          placeholder="Ingresar apellido materno"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Nombres"
          :required="true"
          v-model="form.name"
          placeholder="Ingresar nombres"
          :error="v.name.$error && !v.name.required ? 'Nombres son requeridos' : ''"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-datepicker
          label="Fecha de nacimiento"
          :required="true"
          v-model="form.birthDate"
          :error="v.birthDate.$error && !v.birthDate.required ? 'Fecha de nacimiento es requerida' : ''"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Sexo"
          :required="true"
          v-model="form.gender"
          :items="genderList"
          defaultOption="Elegir sexo"
          :error="v.gender.$error && !v.gender.required ? 'Sexo es requerido' : ''"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Estado civil"
          v-model="form.maritalStatus"
          :items="maritalStatusList"
          defaultOption="Elegir estado civil"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Nacionalidad"
          v-model="form.nationality"
          :items="nationalityList"
          defaultOption="Elegir nacionalidad"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Grupo sanguíneo"
          v-model="form.bloodType"
          :items="bloodTypeList"
          defaultOption="Elegir grupo sanguíneo"
        />
      </div>

    </div>

    <!-- Sección Discapacidad -->
    <div class="flex flex-wrap mt-2 -mx-2">
      <div class="w-full mb-2 px-2">
        <h2 class="form-subtitle">Discapacidad</h2>
      </div>

      <div class="w-full mb-3 px-2">
        <div class="flex items-center gap-2">
          <label class="wz-form-label mb-0 mr-3">Tiene discapacidad</label>
          <wz-checkbox
            v-model="form.hasDisability"
            name="hasDisability"
            switch
            size="lg"
          />
        </div>
      </div>

      <template v-if="form.hasDisability">
        <div class="w-full md:w-1/2 mb-3 px-2">
          <wz-select
            label="Tipo de discapacidad"
            :required="true"
            v-model="form.disabilityType"
            :items="disabilityTypeList"
            defaultOption="Elegir tipo"
            :error="v.disabilityType.$error && !v.disabilityType.required ? 'Tipo de discapacidad es requerido' : ''"
          />
        </div>

        <div class="w-full md:w-1/2 mb-3 px-2">
          <wz-input
            label="Nro. certificado CONADIS"
            :required="true"
            v-model="form.conadisCertificate"
            placeholder="Ingresar número CONADIS"
            :error="v.conadisCertificate.$error && !v.conadisCertificate.required ? 'Nro. certificado CONADIS es requerido' : ''"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Constants } from '@/core/utils'

export default {
  props: {
    form:            { type: Object, required: true },
    v:               { type: Object, required: true },
    districts:       { type: Array,  default: () => [] },
    nationalityList: { type: Array,  default: () => [] },
    identifierTypes: { type: Array,  default: () => [] },
    genderList:      { type: Array,  default: () => [] },
  },
  data() {
    return {
      maritalStatusList:  Object.values(Constants.MaritalStatus),
      bloodTypeList:      Object.values(Constants.BloodType),
      disabilityTypeList: Object.values(Constants.DisabilityType),
    }
  },
}
</script>

<style lang="stylus" scoped></style>
